/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_PendingInputs */

const cs_enum_pending = /** @type {(inputs: Enum_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Čeká`)
};

const en_enum_pending = /** @type {(inputs: Enum_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Enum_PendingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_pending = /** @type {((inputs?: Enum_PendingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_PendingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_pending(inputs)
	return cs_enum_pending(inputs)
});